import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";
const ligasipdusInv = pagesipdus + "2026/Inv/";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 051
        'numConvocatoria' : 'Convocatoria No. 051/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N174-2026.',
        'vigencia' : '19 de octubre al 3 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de la carretera estatal Chalingo - Tzacuala, en el municipio de Huautla.; ubicada en la localidad de Chalingo, Municipio de Huautla, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }51/N174/N174.rar`,
        'start' : '2026-10-19',
        'end' : '2026-11-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N173-2026.',
        'vigencia' : '19 de octubre al 3 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Mejoramiento y ampliación al CERESO Pachuca (edificación de una galera de 2 niveles); ubicada en la localidad de Ejido San Bartolo, Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }51/N173/N173.rar`,
        'start' : '2026-10-19',
        'end' : '2026-11-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N172-2026.',
        'vigencia' : '19 de octubre al 3 de noviembre de 2026.',
        'descripcionProcedimiento' : 'Mejoramiento y ampliación al CERESO Pachuca (edificación de una galera de 1 nivel).; ubicada en la localidad de Ejido San Bartolo, Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }51/N172/N172.rar`,
        'start' : '2026-10-19',
        'end' : '2026-11-03',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 049
        'numConvocatoria' : 'Convocatoria No. 049/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N170-2026.',
        'vigencia' : '12 al 23 de octubre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de la Escuela de Música del Estado de Hidalgo; de Cobertura Estatal.',
        'urlAnexos' : `${ ligasipdus }49/N170/N170.rar`,
        'start' : '2026-10-12',
        'end' : '2026-10-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N169-2026.',
        'vigencia' : '12 al 23 de octubre de 2026.',
        'descripcionProcedimiento' : 'Construcción del nuevo Centro Gerontológico Integral de Huejutla de Reyes (tercera etapa); ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }49/N169/N169.rar`,
        'start' : '2026-10-12',
        'end' : '2026-10-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N168-2026.',
        'vigencia' : '12 al 23 de octubre de 2026.',
        'descripcionProcedimiento' : 'Construcción y Remodelación del Edificio Principal del Instituto Hidalguense de Educación; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }49/N168/N168.rar`,
        'start' : '2026-10-12',
        'end' : '2026-10-23',
        'procedimiento' : 'Licitación Pública',
    }
]